// extracted by mini-css-extract-plugin
module.exports = {"light":"theme_light__2Ue80","dark":"theme_dark__2PouS"};